module.exports = "/images/def_user.png?08cf038ab3d198cbdd0fcb10ae6c5d48";